import View from './View';

class DeleteView extends View {
    constructor(name) {
        super(name);
        this._type = 'DeleteView';
        this._enabled = true;
    }
}

export default DeleteView;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/View/DeleteView.js
 **/